import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { enableProdMode } from '@angular/core';

// OpenTelemetry imports
if (process.env['NODE_ENV'] === 'production') {
 enableProdMode();
}


// ---- Opentelemetry Setup ----
// const provider = new WebTracerProvider();
// registerInstrumentations({
//     instrumentations: [
//         new XMLHttpRequestInstrumentation({
//             propagateTraceHeaderCorsUrls: /.*/,
//         }),F
//         new FetchInstrumentation({
//             propagateTraceHeaderCorsUrls: /.*/,
//         }),
//     ]
// });
  

// ---- End of OpenTelemetry Setup ----

platformBrowserDynamic()
 .bootstrapModule(AppModule)
 .catch((err) => console.error(err));
